import React from "react";
import ReactDOM from "react-dom/client";
import Modal from "react-modal";
import "bootstrap/dist/css/bootstrap.css";
import "./style.css";
import App from "./App";

Modal.setAppElement('#root');

function Main() {
  return (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Main />);
